module.exports = __webpack_public_path__ + "img/icon-ecosystem-gray-dark.497b9308.svg";